<div class="px-10 pb-10">
  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-16">
    <app-mini-loader size="10"></app-mini-loader>
  </div>

  <!-- Data -->
  <app-coauthors-graph *ngIf="!loading && author" [author]="author"></app-coauthors-graph>

  <!-- No data -->
  <app-no-results
    *ngIf="!loading && !author"
    title="Could not load this author's coauthor network"
  ></app-no-results>
</div>
